import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'deleteAccount'
}

export const createSchema = (t: TFunction) => {
  return z.object({
    password: z
      .string({
        required_error: t('content.validation.passwordRequired', tConfig)
      })
      .min(1, t('content.validation.passwordRequired', tConfig)),

    reason: z
      .string({
        required_error: t('content.validation.reasonRequired', tConfig)
      })
      .min(1, t('content.validation.reasonRequired', tConfig)),

    additionalInfo: z
      .string({
        required_error: t('content.validation.tellMoreRequired', tConfig)
      })
      .min(1, t('content.validation.tellMoreRequired', tConfig)),

    deleteConfirmation: z.string()
  })
}

export type DeleteAccountFormData = z.infer<ReturnType<typeof createSchema>>
